// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CanvasWorkspaceSidebar {
  position: fixed;
  z-index: 1300;
  top: 0;
  bottom: 0;
  left: 0;
  width: 88px;
  padding: 12px 8px;
  overflow: hidden;
  background: #ffffff;
  border-right: 1px solid #e2e6e4;
  box-shadow: 8px 0 24px rgba(24, 30, 26, 0.04);
}

.CanvasWorkspaceSidebar-nav {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.CanvasWorkspaceSidebar-item {
  display: flex;
  width: 56px;
  height: 56px;
  flex: 0 0 56px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  padding: 6px;
  color: #737b75;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.1;
  text-align: center;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.CanvasWorkspaceSidebar-item:hover {
  color: #171a17;
  background: #f1f6ed;
  transform: translateY(-1px);
}

.CanvasWorkspaceSidebar-item.is-active {
  color: #315327;
  background: #e3f3cb;
  border-color: #b9df8a;
  box-shadow: 0 6px 16px rgba(112, 163, 61, 0.12);
}

.CanvasWorkspaceSidebar-item-icon,
.CanvasWorkspaceSidebar-item-icon svg {
  display: block;
  width: 21px;
  height: 21px;
}

.CanvasWorkspaceSidebar-item-icon {
  color: inherit;
}

.CanvasWorkspaceSidebar-item-label {
  letter-spacing: 0.02em;
}

@media (max-width: 768px) {
  .CanvasWorkspaceSidebar {
    width: 76px;
    padding: 10px 4px;
  }

  .CanvasWorkspaceSidebar-item {
    width: 52px;
    height: 52px;
    flex-basis: 52px;
    font-size: 10px;
  }
}

@media (max-width: 720px) {
  .CanvasWorkspaceSidebar {
    width: 68px;
    padding: 8px 3px;
  }

  .CanvasWorkspaceSidebar-item {
    width: 48px;
    height: 48px;
    flex-basis: 48px;
    gap: 3px;
    font-size: 9px;
  }

  .CanvasWorkspaceSidebar-item-icon,
  .CanvasWorkspaceSidebar-item-icon svg {
    width: 19px;
    height: 19px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CanvasWorkspaceSidebar/CanvasWorkspaceSidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kGAAkG;AACpG;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".CanvasWorkspaceSidebar {\n  position: fixed;\n  z-index: 1300;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 88px;\n  padding: 12px 8px;\n  overflow: hidden;\n  background: #ffffff;\n  border-right: 1px solid #e2e6e4;\n  box-shadow: 8px 0 24px rgba(24, 30, 26, 0.04);\n}\n\n.CanvasWorkspaceSidebar-nav {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.CanvasWorkspaceSidebar-item {\n  display: flex;\n  width: 56px;\n  height: 56px;\n  flex: 0 0 56px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 5px;\n  padding: 6px;\n  color: #737b75;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 650;\n  line-height: 1.1;\n  text-align: center;\n  cursor: pointer;\n  transition: color 160ms ease, background 160ms ease, border-color 160ms ease, transform 160ms ease;\n}\n\n.CanvasWorkspaceSidebar-item:hover {\n  color: #171a17;\n  background: #f1f6ed;\n  transform: translateY(-1px);\n}\n\n.CanvasWorkspaceSidebar-item.is-active {\n  color: #315327;\n  background: #e3f3cb;\n  border-color: #b9df8a;\n  box-shadow: 0 6px 16px rgba(112, 163, 61, 0.12);\n}\n\n.CanvasWorkspaceSidebar-item-icon,\n.CanvasWorkspaceSidebar-item-icon svg {\n  display: block;\n  width: 21px;\n  height: 21px;\n}\n\n.CanvasWorkspaceSidebar-item-icon {\n  color: inherit;\n}\n\n.CanvasWorkspaceSidebar-item-label {\n  letter-spacing: 0.02em;\n}\n\n@media (max-width: 768px) {\n  .CanvasWorkspaceSidebar {\n    width: 76px;\n    padding: 10px 4px;\n  }\n\n  .CanvasWorkspaceSidebar-item {\n    width: 52px;\n    height: 52px;\n    flex-basis: 52px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 720px) {\n  .CanvasWorkspaceSidebar {\n    width: 68px;\n    padding: 8px 3px;\n  }\n\n  .CanvasWorkspaceSidebar-item {\n    width: 48px;\n    height: 48px;\n    flex-basis: 48px;\n    gap: 3px;\n    font-size: 9px;\n  }\n\n  .CanvasWorkspaceSidebar-item-icon,\n  .CanvasWorkspaceSidebar-item-icon svg {\n    width: 19px;\n    height: 19px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
